import Link from 'next/link'
import styled, { css } from 'styled-components'

import Image from 'shared/components/Image'
// import { useWindowSize } from 'shared/hooks/useWindowSize'
import { colors, fonts, media } from 'shared/lib'
import { Article } from 'shared/types/Article'

type ArticleTileProps = {
  article: Article
  index: number
}

// TODO: Uncomment isLargeTile boolean and imports after editorial MVP
// Request by product to not have large tile styles for initial release
// export const ArticleTile = ({ article, index }: ArticleTileProps) => {
export const ArticleTile = ({ article }: ArticleTileProps) => {
  // const { isMobile } = useWindowSize()
  const date = new Date(article?.publishTime).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  // const isLargeTile = (index + 1) % 5 === 0 && !isMobile
  const isLargeTile = false

  return (
    <Container $isLargeTile={isLargeTile}>
      <Link data-qa="ArticleTileImageLink" href={`/article/${article?.slug}`}>
        <ImageContainer $isLargeTile={isLargeTile}>
          <Image
            alt={article?.subject}
            data-qa="ArticleTileImage"
            src={article?.coverPicture?.url}
            height={isLargeTile ? 882 : 578}
            width={isLargeTile ? 705 : 462}
          />
        </ImageContainer>
      </Link>
      <DetailsContainer>
        <TopContent>
          <Link data-qa="ArticleTileTitleLink" href={`/article/${article?.slug}`}>
            <TitleContainer data-qa="ArticleTileTitle">{article?.subject}</TitleContainer>
          </Link>
          <DateContainer data-qa="ArticleTileDate">{date}</DateContainer>
        </TopContent>
        <DescriptionContainer data-qa="ArticleTileDescription">
          {article?.description}
        </DescriptionContainer>
      </DetailsContainer>
    </Container>
  )
}

const Container = styled.div<{ $isLargeTile: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 56px;
  margin-left: 24px;
  margin-right: 24px;

  ${media.medium`
    margin-bottom: 120px;
    margin-left: 0px;
    margin-right: 0px;
    width: 462px;
  `};

  ${({ $isLargeTile }) =>
    $isLargeTile &&
    css`
      ${media.medium`
        grid-column: 1 / -1;
        justify-self: center;
        width: 705px;
      `};
    `};

  a {
    text-decoration: none;
  }
`
const DateContainer = styled.div`
  color: ${colors.FC2_RED};
  font-family: 'Ivar Text'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 14px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.056px;
  text-align: right;
  white-space: nowrap;
`
const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  width: 100%;
`
const DescriptionContainer = styled.div`
  color: ${colors.FC2_RED};
  font-family: 'Ivar Text'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 14px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.056px;
  padding-right: 64px;

  ${media.medium`
    padding-right: 120px;
  `};
`
const ImageContainer = styled.div<{ $isLargeTile: boolean }>`
  align-items: center;
  display: flex;
  width: calc(100vw - 48px);

  ${({ $isLargeTile }) =>
    $isLargeTile
      ? css`
          ${media.medium`
            width: 705px;
          `};
        `
      : css`
          ${media.medium`
            width: 462px;
          `};
        `};

  img {
    height: auto;
    object-fit: cover;
  }
`
const TitleContainer = styled.div`
  color: ${colors.FC2_RED};
  ${fonts.STANDARD};
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  text-transform: uppercase;
`
const TopContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 2px;

  ${media.medium`
    margin-bottom: 3px;
  `};
`
